/**
 * @param  {string} name of cookie
 * @param  {string=} allCookies - defaults to document.cookie
 * @return {string} cookie value
 */
export const getCookie = (name: string, allCookies: string = document.cookie): string => {
  let valueStart, valueEnd;

  if (allCookies.length > 0) {
    const encodedName = encodeURIComponent(name);

    valueStart = allCookies.indexOf(`${encodedName}=`);

    if (valueStart !== -1) {
      valueStart = valueStart + encodedName.length + 1;
      valueEnd = allCookies.indexOf(";", valueStart);

      if (valueEnd === -1) {
        valueEnd = allCookies.length;
      }

      return decodeURIComponent(allCookies.substring(valueStart, valueEnd));
    }
  }
  return "";
};
